import { render, staticRenderFns } from "./CoinHealth.vue?vue&type=template&id=6c2eb3e6&scoped=true&"
import script from "./CoinHealth.vue?vue&type=script&lang=js&"
export * from "./CoinHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2eb3e6",
  null
  
)

export default component.exports